import { createSelector } from 'reselect'
import RootState from 'store/state'

export const selectSettingsState = (state: RootState) => state.settings

export const selectAppSettingsConfigurations = createSelector(
    selectSettingsState,
    (settings) => settings?.settings?.appConfigurations,
)
